export const profanityAllowlist = ["butt", "butts", "butthole", "buttholes"];
export const profanityBlocklist = [];
